/**
 * Реестр модалок для выбора параметров отчетов
 *
 * Каждая модалка должна:
 * 1. Иметь метод open()
 * 2. Эмитить событие 'ready' с объектом параметров { key: value }
 * 3. Эмитить событие 'closed' при закрытии
 */

import Vue from 'vue'
import { createDataCollectionIdModal } from './utils'

type ModalCreator = (parent: Vue, propsData: unknown) => Promise<Vue & { open: () => Promise<void> }>

type ModalsRegistry = {
  [key: string]: ModalCreator;
}

export const MODALS_REGISTRY: ModalsRegistry = {
  /**
   * Модалка для выбора ID сбора данных
   * Эмитит: { data_collection_id: number }
   */
  DataCollectionIdModal: createDataCollectionIdModal,

  // Добавьте здесь другие модалки:
  // CustomModal: createCustomModal,
}

/**
 * Получить функцию создания модалки по имени
 */
export const getModalCreator = (modalName: string | null) => {
  // eslint-disable-next-line no-console
  console.log('getModalCreator called with:', modalName)
  // eslint-disable-next-line no-console
  console.log('MODALS_REGISTRY:', MODALS_REGISTRY)

  if (!modalName) {
    // eslint-disable-next-line no-console
    console.log('modalName is falsy, returning null')
    return null
  }

  const creator = MODALS_REGISTRY[modalName]
  if (!creator) {
    // eslint-disable-next-line no-console
    console.warn(`Modal "${modalName}" not found in registry`)
    return null
  }

  // eslint-disable-next-line no-console
  console.log('Found creator:', creator)
  return creator
}

